import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Form } from "react-bootstrap";
import ColumnResizer from "react-table-column-resizer";
export function ProductTableFilterDisplay(_param) {
    var filterDisplay = _param.filterDisplay, setFilterDisplay = _param.setFilterDisplay, setModalDisplayFilter = _param.setModalDisplayFilter, filterdisplayName = _param.filterdisplayName, props = _object_without_properties(_param, [
        "filterDisplay",
        "setFilterDisplay",
        "setModalDisplayFilter",
        "filterdisplayName"
    ]);
    var SaveDisplay = function() {
        localStorage.setItem(filterdisplayName, JSON.stringify(filterDisplay));
        setModalDisplayFilter(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-3",
        children: [
            /*#__PURE__*/ _jsxs("table", {
                className: "column_resize_table table1 table-striped ",
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    children: "สถานะ"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "รายการแสดงผล"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 300
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("tbody", {
                        children: Object.entries(filterDisplay).map(function(param) {
                            var _$_param = _sliced_to_array(param, 2), key = _$_param[0], value = _$_param[1];
                            return /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            type: "switch",
                                            id: "custom-switch",
                                            className: "ms-4 mt-2 mb-1",
                                            label: "",
                                            checked: value.isActive,
                                            onChange: function(e) {
                                                setFilterDisplay(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), _define_property({}, key, _object_spread_props(_object_spread({}, prev[key]), {
                                                        isActive: e.target.checked
                                                    })));
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: value.name
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "d-flex align-items-center pb-4 pt-5 ",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    className: "btn-st-3 ms-auto me-3 btn",
                    onClick: function() {
                        return SaveDisplay();
                    },
                    children: "ตกลง"
                })
            })
        ]
    });
}
